import { CustomGizmoHelper } from 'app/modules/wallforming/components/scenes/camera-controls/CustomGizmoHelper';
import { CustomGizmoViewcube } from 'app/modules/wallforming/components/scenes/camera-controls/CustomGizmoViewcube';
import { cameraUpVectors } from 'app/modules/wallforming/components/scenes/camera-controls/utils/cameraUtils';

export const PreviewOrientationCube = () => {
    return (
        <CustomGizmoHelper alignment="top-right" margin={[40, 40]} scale={0.8}>
            <CustomGizmoViewcube
                backgroundColor="#d8d9df"
                faces={['Right', 'Left', 'Back', 'Front', 'Top', 'Bottom']}
                font="bold 30px Inter, Arial, sans-serif"
                hoverColor="#a4a5a8"
                strokeColor="#000000"
                textColor="#000000"
                upVectors={cameraUpVectors}
            />
        </CustomGizmoHelper>
    );
};
